import {
  loginSuccess,
  loginFail,
  userDataUpdated,
  changePasswordSuccess,
  changePasswordFailed,
  changePasswordStateClearSuccess,
  paymentDataByAccountIDSuccess,
  paymentDataByAccountIDFail,
  getUserByAccountIDSuccess,
  getUserByAccountIDFail,
  switchAccountByID,
  switchBackAccount,
  clearStates,

} from "../constant";
import { toast } from "react-toastify";

export const initialState = {
  user: null,
  paymentData: null,
  tokens: {},
  data: {},
  userCreated: false,
  passwordUpdate: "",
  loginError: null,
  changePasswordError: null,
  accountIdData: null,
  switchAccount: false,
  originalData: null,
  originalTokens: null,
  isSwitched: false,
  accountIdDataError: null
};

let toastConfig = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 2500,
};

export default function (state = initialState, action) {

  switch (action.type) {
    case loginSuccess:
      toast.success("login Successfully", toastConfig);
      return {
        ...state,
        data: action.payload.user,
        tokens: action.payload.tokens,
      };
    case loginFail:
      toast.error(action.payload.message, toastConfig);
      return {
        ...state,
        loginError: action.payload.message,
        user: null,
      };
    case userDataUpdated:
      return {
        ...state,
        data: action.payload,
      };
    case changePasswordSuccess:
      return {
        ...state,
        passwordUpdateSuccess: action.payload,
      };
    case changePasswordFailed:
      return {
        ...state,
        passwordUpdateFailed: action.payload.message,
      };
    case changePasswordStateClearSuccess:
      return {
        ...state,
        passwordUpdateSuccess: null,
        passwordUpdateFailed: null,
      };
    case paymentDataByAccountIDSuccess:
      return {
        ...state,
        paymentData: action.payload,
      };
    case paymentDataByAccountIDFail:
      return {
        ...state,
        paymentData: action.payload.message,
      };
    case getUserByAccountIDSuccess:
      return {
        ...state,
        accountIdDataError:null,
        accountIdData: action.payload,
      };
    case getUserByAccountIDFail:
      return {
        ...state,
        accountIdData: null,
        accountIdDataError: action.payload.message,
      };
    case switchAccountByID:
      return {
        ...state,
        isSwitched: true,
        originalData: state.data,
        originalTokens: state.tokens,
        data: action.payload,
      };
    case switchBackAccount:
      return {
        ...state,
        data: state.originalData,
        tokens: state.originalTokens,
        originalData: null,
        originalTokens: null,
        isSwitched: false,
        accountIdData: null
      };
      case clearStates:
      return {
        ...state,
        accountIdData:null,
        accountIdDataError: null,
      };

    default:
      return state;
  }
}
